var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.uiSuccess )?_c('div',{staticClass:"outer-wrapper"},[_c('font-awesome-icon',{staticClass:"success-icon",style:({ color: _vm.iconColor }),attrs:{"icon":"check-circle"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }